import { useEffect, useState } from 'react';

/** Current time, re-rendering on each second (or minute) boundary. */
export function useNow(resolution: 'second' | 'minute' = 'second'): Date {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const step = resolution === 'second' ? 1000 : 60_000;
    let timer: number;
    const tick = () => {
      const d = new Date();
      setNow(d);
      timer = window.setTimeout(tick, step - (d.getTime() % step) + 5);
    };
    timer = window.setTimeout(tick, step - (Date.now() % step) + 5);
    return () => window.clearTimeout(timer);
  }, [resolution]);
  return now;
}
